module.exports = __webpack_public_path__ + "img/icon-account-payment-methods@3x.db10696b.png";